import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Nav, NavDropdown } from 'react-bootstrap'
import clsx from 'clsx'
import { findAllParent, findMenuItem, getMenuItemFromURL, getMenuItems, clearMenuCache } from '../../../../helpers/Menu'
import IconifyIcon from '../../../../components/wrapper/IconifyIcon'

const TopMenu = () => {
    const [menuItems, setMenuItems] = useState([])
    const location = useLocation()
    const pathname = location.pathname
    const [activeMenuItems, setActiveMenuItems] = useState([])

    const loadMenuItems = async () => {
        try {
            const items = await getMenuItems()
            setMenuItems(items)
        } catch (error) {
            console.error('Error loading menu items:', error)
            // Fallback to empty menu or handle error appropriately
            setMenuItems([])
        }
    }

    useEffect(() => {
        loadMenuItems()

        const updateMenu = () => {
            clearMenuCache() // Clear cache when filters are updated
            loadMenuItems()
        }

        window.addEventListener('gameFiltersUpdated', updateMenu)
        window.addEventListener('languageChanged', updateMenu)

        return () => {
            window.removeEventListener('gameFiltersUpdated', updateMenu)
            window.removeEventListener('languageChanged', updateMenu)
        }
    }, [])

    useEffect(() => {
        const trimmedURL = pathname?.trim() || ''
        const matchingMenuItem = getMenuItemFromURL(menuItems, trimmedURL)
        if (matchingMenuItem) {
            const activeMt = findMenuItem(menuItems, matchingMenuItem.key)
            if (activeMt) {
                setActiveMenuItems([activeMt.key, ...findAllParent(menuItems, activeMt)])
            }
        }
    }, [pathname, menuItems])

    const getActiveClass = (item) => {
        return activeMenuItems?.includes(item.key) ? 'active' : ''
    }

    return (
        <Nav className="top-menu d-none d-lg-flex align-items-center">
            {(menuItems || []).map((item, idx) => {
                if (item.isTitle) {
                    return (
                        <div key={item.key + idx} className="top-menu-title px-3 text-muted small fw-bold">
                            {item.label}
                        </div>
                    )
                }
                if (item.children) {
                    return (
                        <NavDropdown
                            title={
                                <>
                                    <span className="me-1">{item.label}</span>
                                    <IconifyIcon icon="mdi:chevron-down" width="16" height="16" className="ms-1 opacity-75" />
                                </>
                            }
                            key={item.key + idx}
                            id={`nav-dropdown-${item.key}`}
                            className={clsx('top-menu-item', getActiveClass(item))}
                        >
                            <div className={item.key === 'more' ? 'more-dropdown-panel' : ''}>
                                {item.children.map((child, childIdx) => {
                                    if (child.isPromo) {
                                        return (
                                            <a
                                                href={child.url}
                                                key={child.key + childIdx}
                                                className="nav-promo-banner"
                                            >
                                                <span>{child.label}</span>
                                            </a>
                                        )
                                    }
                                    if (child.isTitle) {
                                        return (
                                            <div key={child.key + childIdx} className="nav-section-header">
                                                {child.label}
                                            </div>
                                        )
                                    }
                                    if (child.isSeparator) {
                                        return <div key={child.key + childIdx} className="dropdown-separator"></div>
                                    }
                                    if (child.isFooter) {
                                        return (
                                            <div key={child.key + childIdx} className="nav-footer">
                                                <span className="nav-footer-text">{child.label}</span>
                                                <div className="nav-footer-socials">
                                                    {(child.socials || []).map((social, sIdx) => (
                                                        <a
                                                            key={sIdx}
                                                            href={social.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="nav-footer-social-link"
                                                        >
                                                            <IconifyIcon icon={social.icon} />
                                                        </a>
                                                    ))}
                                                </div>
                                            </div>
                                        )
                                    }
                                    // Default Item
                                    return (
                                        <NavDropdown.Item
                                            as={Link}
                                            to={child.url}
                                            key={child.key + childIdx}
                                            className={clsx('custom-dropdown-item', getActiveClass(child))}
                                        >
                                            <span>{child.label}</span>
                                            <IconifyIcon icon="mdi:chevron-right" className="item-arrow" width="18" height="18" />
                                        </NavDropdown.Item>
                                    )
                                })}
                            </div>
                        </NavDropdown>
                    )
                }
                return (
                    <Nav.Link
                        as={Link}
                        to={item.url}
                        key={item.key + idx}
                        className={clsx('top-menu-item', getActiveClass(item))}
                    >
                        {item.label}
                    </Nav.Link>
                )
            })}
        </Nav>
    )
}

export default TopMenu
